import { Link } from 'react-router-dom'
import clsx from 'clsx'

import {
  AvatarSize,
  StackedApp,
  StackedAppItem,
  StackedAppProps,
  StackedAvatar,
  StackedAvatarItem,
  StackedAvatarProps,
  Td,
} from '@makyoapp/makyo-ui'

import { ORG_ROUTE, PROJECT_ROUTE } from '@/shared/constants'

export function StackedAvatarTd(props: StackedAvatarProps<StackedAvatarItem>) {
  return (
    <Td className={clsx('stacked-items', props.className)}>
      {props.items.length > 0 && (
        <StackedAvatar
          items={props.items}
          defaultSize={false}
          avatarProps={{
            size: AvatarSize.M2,
          }}
          renderLink={props.renderLink}
        />
      )}
    </Td>
  )
}

export function StackedCustomerTd(props: StackedAvatarProps<StackedAvatarItem>) {
  return <StackedAvatarTd {...props} />
}

export function StackedOrgTd(props: StackedAvatarProps<StackedAvatarItem>) {
  return (
    <StackedAvatarTd
      {...props}
      renderLink={(node, item) => {
        return (
          <Link title={item.name} to={`/${ORG_ROUTE}/${item.id}`}>
            {node}
          </Link>
        )
      }}
    />
  )
}

export function StackedTeamTd(props: StackedAvatarProps<StackedAvatarItem>) {
  return <StackedAvatarTd {...props} />
}

export function StackedAppTd(props: StackedAppProps<StackedAppItem>) {
  return (
    <Td className={clsx('stacked-items', props.className)}>
      {props.items.length > 0 && (
        <StackedApp
          items={props.items}
          renderLink={(node, item) => {
            return <Link to={`${PROJECT_ROUTE}/${item.id}`}>{node}</Link>
          }}
          defaultSize={false}
          className='w-9 h-9 overflow-hidden'
        />
      )}
    </Td>
  )
}
